const mediaQueries = {
  '1024px': 1024
};

export default mediaQueries;
